import { Component } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Store, Select } from '@ngxs/store';

import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

import {
    AlertService,
    ButtonColors,
    ButtonModule,
    LayerService,
    NumberfieldModule,
    TextfieldModule,
} from '@ed---interne/ng-uui-components';
import { CreatePhase, ProjectsState } from '../../../../project.state';
import { CommonModule } from '@angular/common';
import { SharedModule } from 'src/app/shared/shared.module';
import { RouterModule } from '@angular/router';
import { Observable } from 'rxjs';
import { EDSearchComponent } from 'src/app/shared/components/ed-search/ed-search.component';
import { ProjectModel, ResearchCategory } from '../../../../project.models';

@UntilDestroy()
@Component({
    selector: 'phase-create',
    templateUrl: './phase-create.component.html',
    styleUrls: ['./phase-create.component.scss'],
    standalone: true,
    schemas: [],
    imports: [
        CommonModule,
        ReactiveFormsModule,
        FormsModule,
        SharedModule,
        TextfieldModule,
        ButtonModule,
        NumberfieldModule,
        RouterModule,
        EDSearchComponent,
    ],
})
export class PhaseCreateComponent {
    public buttonColors = ButtonColors;

    public header: string = '';

    @Select(ProjectsState.researchCategories)
    public researchCategories$!: Observable<ResearchCategory[]>;
    public researchCategoryOptions: { value: string; label: string }[] = [];

    @Select(ProjectsState.projectWithDetail)
    public project$!: Observable<ProjectModel>;
    public project: ProjectModel | undefined;

    public phaseFormGroup: FormGroup = this.formBuilder.group({
        code: [''],
        label: [''],
        researchCategoryId: [undefined],
    });

    constructor(
        private readonly formBuilder: FormBuilder,
        private readonly layerService: LayerService,
        private readonly store: Store,
        private readonly alertService: AlertService,
    ) {
        this.researchCategories$
            .pipe(untilDestroyed(this))
            .subscribe((researchCategories: ResearchCategory[]) => {
                this.researchCategoryOptions = researchCategories.map((a) => ({
                    value: a.id!,
                    label: a.label,
                }));
            });

        this.project$.pipe(untilDestroyed(this)).subscribe((project: ProjectModel) => {
            if (!project) return;

            this.project = project;
            this.phaseFormGroup = this.formBuilder.group({
                code: [`${this.project.code}-${this.project.phases?.length || 1}`],
                label: [''],
                researchCategoryId: [undefined],
            });
        });
    }

    public updateResearchCategoryId(id: any) {
        this.phaseFormGroup.patchValue({ researchCategoryId: id });
    }

    public valid(): void {
        if (!this.project) return;

        const phase: any = {
            code: this.phaseFormGroup.value.code,
            label: this.phaseFormGroup.value.label,
            researchCategoryId: this.phaseFormGroup.value.researchCategoryId,
        };
        //create
        this.store.dispatch(new CreatePhase({ phase, projectId: this.project.id! })).subscribe({
            next: () => {
                this.alertService.valid('Création', `Phase "${phase.label} "créé !`);
                this.close();
            },
            error: (err: any) => {
                console.info(err.error.message);
                this.alertService.error('Création', err.error.msg);
            },
        });
    }
    public set params(params: { header: string }) {
        this.header = params.header;
    }

    public close() {
        this.layerService.close();
    }

    public canCreateEdit(): boolean {
        return this.phaseFormGroup.invalid || !this.phaseFormGroup.dirty;
    }
}
